export enum OfferModalLatestNavType {
    NEXT = "next",
    PREV = "prev"
}
